export const Principal = "IA PRINCIPAL";
export const Agent = "IA PRIMARY AGENT";
export const Producer = "IA PRODUCER";